import Vue from 'vue'
import PackageTransformer from '../../transformers/extranet/PackageTransformer'

/**
 * @author Andrés Aguilar <andresyoshimar@gmail.com>
 */

const fetchPackages = (param = { status: 'to-authorize' }) => {
  let config = null
  if (param) {
    config = {
      params: param,
    }
  }
  return Vue.$http.get('extranet/package/', config)
    .then((response) => { return PackageTransformer.fetchCollection(response.data) })
    .catch((err) => { throw err })
}

export default fetchPackages


// WEBPACK FOOTER //
// ./src/services/extranet/fetchPackages.js